module.exports = __webpack_public_path__ + "static/media/lisaClark.c6a5a010.jpg";